// react documenation used: https://react.dev/learn
// axios documentation used: https://axios-http.com/docs/intro
import React, { useState, useEffect } from "react";
import axios from "axios";
import Nav from "../../layout/navBar/navBar";
import Recent from "../../layout/recentBar/recentBar";
import styles from "./favouritesPage.module.css";
import CategoryRepoDetails from "../../layout/categoryRepoDetails/categoryRepoDetails";

function FavouritesPage() {
  const [favorites, setFavorites] = useState([]);
  const [selectedRepo, setSelectedRepo] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchFavourites = async () => {
      const token = localStorage.token;
      try {
        const response = await axios.get(`${apiUrl}/api/requests/favourites`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setFavorites(response.data);
      } catch (error) {
        console.error("Error fetching favorite repositories:", error);
      }
    };

    fetchFavourites();
  });

  // functions to open and close repository detail cards
  const handleRepoSelect = (repo) => {
    setSelectedRepo(repo);
  };

  const handleClosePopup = () => {
    setSelectedRepo(null);
  };

  // assigns platform logo from public folder
  const getPlatformIcon = (url) => {
    if (url.includes("github.com")) {
      return "/github.png";
    } else if (url.includes("gitlab.com")) {
      return "/gitlab.png";
    } else {
      return null;
    }
  };

  return (
    <div>
      <Nav />
      <div className={styles.home}>
        <header className={styles.header}></header>
        <main className={styles.mainContent}>
          <section className={styles.recentlyAccessed}>
            <Recent />
          </section>
          <section className={styles.sharedRepositories}>
            <h2>Favourited Repositories</h2>
            <div className={styles.reposContainer}>
              {favorites.map((repo, index) => (
                <div
                  key={index}
                  className={styles.repoCard}
                  onClick={() => handleRepoSelect(repo)}
                >
                  <img
                    src={getPlatformIcon(repo.repository_url)}
                    alt="Platform Icon"
                    style={{ width: "20px", marginRight: "10px" }}
                  />
                  {repo.repository_name}
                </div>
              ))}
            </div>
          </section>
        </main>
        {selectedRepo && (
          <CategoryRepoDetails repo={selectedRepo} onClose={handleClosePopup} />
        )}
      </div>
    </div>
  );
}

export default FavouritesPage;
